import { DAILY_ATTENDANCE_REQUEST, ATTENDANCE_REQUEST } from "../actions/utilities";
const INITIAL_STATE = {
    dailyAttendanceLoading: false,
    dailyAttendanceSuccess: false,
    dailyAttendanceFailure: false,
    dailyAttendanceError: null,
    dailyAttendance: [],
    attendanceLoading: false,
    attendanceSuccess: false,
    attendanceFailure: false,
    attendanceError: null,
    attendance: [],
}

export const dailyAttendanceReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case DAILY_ATTENDANCE_REQUEST.GET_DAILY_ATTENDANCE_REPORT_REQUEST:
            return {
                ...state,
                dailyAttendanceLoading: true,
                dailyAttendanceSuccess: false,
                dailyAttendanceFailure: false,
                dailyAttendanceError: null
            }
        case DAILY_ATTENDANCE_REQUEST.GET_DAILY_ATTENDANCE_REPORT_SUCCESS:
            // console.log("im here::")
            return {
                ...state,
                dailyAttendanceLoading: false,
                dailyAttendanceSuccess: true,
                dailyAttendanceFailure: false,
                dailyAttendanceError: null,
                dailyAttendance: action.payload
            }
        case DAILY_ATTENDANCE_REQUEST.GET_DAILY_ATTENDANCE_REPORT_FAILURE:
            return {
                ...state,
                dailyAttendanceLoading: false,
                dailyAttendanceSuccess: false,
                dailyAttendanceFailure: true,
                dailyAttendanceError: action.payload
            }
        case ATTENDANCE_REQUEST.GET_ATTENDANCE_REPORT_REQUEST:
            return {
                ...state,
                attendanceLoading: true,
                attendanceSuccess: false,
                attendanceFailure: false,
                attendanceError: null
            }
        case ATTENDANCE_REQUEST.GET_ATTENDANCE_REPORT_SUCCESS:
            return {
                ...state,
                attendanceLoading: false,
                attendanceSuccess: true,
                attendanceFailure: false,
                attendanceError: null,
                attendance: action.payload
            }
        case ATTENDANCE_REQUEST.GET_ATTENDANCE_REPORT_FAILURE:
            return {
                ...state,
                attendanceLoading: false,
                attendanceSuccess: false,
                attendanceFailure: true,
                attendanceError: action.payload
            }
        default:
            return state;
    }
}